import type { SiteRoute } from "@lumora/ui";

/** The one route registry for navbar and footer. Contact lives inside About; only legal is footerOnly. */
export const SITE_ROUTES: readonly SiteRoute[] = [
  { path: "/pricing", label: "Pricing" },
  { path: "/apps", label: "Apps" },
  { path: "/developers", label: "API" },
  { path: "/about", label: "About" },
  { path: "/terms", label: "Terms", footerOnly: true },
  { path: "/privacy", label: "Privacy", footerOnly: true },
];
